<div class="page-not-found-container">
  <div class="error-code">404</div>
  <div class="message">Oops! The page you're looking for doesn't exist.</div>
  <a routerLink="/login" class="btn-go-back">Go to Login</a>
</div>
